import { Text } from '@adc/parallax-component-library';

import { PatientCreateSteps } from '~/features/patientCreation/constants';
import type { PatientFormType } from '~/features/patientCreation/types';
import { buildTestId } from '~/utils/buildTestId';

type FoundPatientMessageProps = {
  step: string;
  patient: PatientFormType;
  testID: string;
};

export const FoundPatientMessage = ({
  step,
  patient,
  testID,
}: FoundPatientMessageProps) => {
  if (step === PatientCreateSteps.PATIENT_ALREADY_EXISTS) {
    return (
      <Text
        type="$bodyBase.default"
        testID={buildTestId({
          testID,
          suffix: ['already', 'exist', 'account', 'found'],
        })}
      >
        <Text type="$bodyBase.medium">
          {patient.firstName} {patient.lastName}
        </Text>{' '}
        is already a patient in this department. <br />
        Select “Go to Patient” to view/edit the patient’s profile or re-send an
        invitation to the patient.
      </Text>
    );
  }

  if (step === PatientCreateSteps.PATIENT_ARCHIVED_ACCOUNT_FOUND) {
    return (
      <Text
        type="$bodyBase.default"
        testID={buildTestId({
          testID,
          suffix: ['archived', 'account', 'found'],
        })}
      >
        <Text type="$bodyBase.medium">
          {patient.firstName} {patient.lastName}
        </Text>{' '}
        is currently in this department’s archive folder. <br />
        Select “Next” to review and restore the patient’s profile.
      </Text>
    );
  }
  if (step === PatientCreateSteps.PATIENT_ANOTHER_DEPARTMENT_ACCOUNT_FOUND) {
    return (
      <Text
        type="$bodyBase.default"
        testID={buildTestId({
          testID,
          suffix: ['patient', 'found', 'message'],
        })}
      >
        A patient profile already exists for{' '}
        <Text type="$bodyBase.medium">
          {patient.firstName} {patient.lastName}
        </Text>{' '}
        at another department:{' '}
        <Text type="$bodyBase.medium">Outpatient Monitoring</Text>. Select
        “Next” to continue transferring the patient to your current department:{' '}
        <Text type="$bodyBase.medium">HF RPM</Text>. The patient’s details can
        be confirmed on the next page.
      </Text>
    );
  }

  return (
    <Text
      type="$bodyBase.default"
      testID={buildTestId({
        testID,
        suffix: ['patient', 'found', 'message'],
      })}
    >
      No message available for this step.
    </Text>
  );
};
